export enum ICDNResponseCommand {
  INITIALIZATION_COMPLETE,
  INITIALIZATION_ERROR,
  LOAD_COMPLETE,
  UPDATE_VALUE,
  UPDATE_VISIBILITY,
  PERFORM_VALIDATION,
  /** @deprecated */
  REFRESH_VALUE,
  REGISTER_AUX_REF,
  REGISTER_DEPENDENCY,
  REQUEST_RATE,
  RESET_ACK,
}
